import { render, staticRenderFns } from "./uniform.vue?vue&type=template&id=8943b8d4&scoped=true&"
import script from "./uniform.vue?vue&type=script&lang=js&"
export * from "./uniform.vue?vue&type=script&lang=js&"
import style0 from "./uniform.vue?vue&type=style&index=0&id=8943b8d4&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8943b8d4",
  null
  
)

export default component.exports